{
    "formName": "Create New Charge",
    "formRows": [
      {
        "formGroups": [
          {
            "style": { "gridColumn": "span 3" },
            "control": {
              "label": "code",
              "displayLabel": "Charge Code",
              "disabled": false,
              "placeHolder": "Ex:12345",
              "fieldInfo": { "dataType": "text" },
              "validators": [{ "type": "required", "message": "Charge Code is required" }]
            }
          },
          {
            "style": { "gridColumn": "span 3" },
            "control": {
              "label": "name",
              "displayLabel": "Charge Name",
              "disabled": false,
              "placeHolder": "Ex:12345",
              "fieldInfo": { "dataType": "text" },
              "validators": [{ "type": "required", "message": "Charge Name is required" }]
            }
          }
        ]
      },
      {
        "formGroups": [
          {
            "style": { "gridColumn": "span 3" },
            "control": {
              "label": "printName",
              "displayLabel": "Print Name",
              "disabled": false,
              "placeHolder": "Ex:12345",
              "fieldInfo": { "dataType": "text" },
              "validators": [{ "type": "required", "message": "Print Name is required" }]
            }
          },
          {
            "style": { "gridColumn": "span 3" },
            "control": {
              "label": "hsnOrSacCode",
              "displayLabel": "HSN/SAC Code",
              "disabled": false,
              "placeHolder": "Ex:12345",
              "fieldInfo": { "dataType": "text" },
              "validators": [
                { "type": "required", "message": "HSN/SAC Code is required" },
                {"type":  "minlength", "message": "HSN/SAC Code should be minimum 4 characters long", "params": 4},
                {"type":  "maxlength", "message": "HSN/SAC Code should be maximum 8 characters long", "params": 8}
              ]
            }
          }
        ]
      },
      {
        "formGroups": [
          {
            "style": { "gridColumn": "span 3" },
            "control": {
              "label": "inventoryType",
              "displayLabel": "Inventory Type",
              "disabled": false,
              "placeHolder": "Ex:12345",
              "fieldInfo": { 
                "dataType": "select",
                "options": [
                  {
                    "label": "Container",
                    "value": "CONTAINER"
                  },
                  {
                    "label": "Cargo",
                    "value": "CARGO"
                  }
                ]
              },
              "validators": [
                { "type": "required", "message": "Inventory Type is Required" }
              ]
            }
          },
          {
            "style": {
              "gridColumn": "span 3"
            },
            "control": {
              "label": "storageCharge",
              "displayLabel": "Storage Charge",
              "placeHolder": "Enter Storage Charge",
              "skipLabel": true,
              "disabled": false,
              "fieldInfo": {
                "dataType": "boolean"
              }
            }
          }
        ]
      },
      {
        "formGroups": [
          {
            "style": { "gridColumn": "span 3" },
            "control": {
              "label": "serviceId",
              "displayLabel": "Service",
              "disabled": false,
              "placeHolder": "Select Service",
              "returnRawValue": false,
              "fieldInfo": {
                "dataType": "picklist",
                "lookupDetails": {
                  "apiUrl": "v1/services/list",
                  "filterByKeys": ["NAME_CONTAINS"],
                  "limit": 10,
                  "orderBy": { "name": "asc" },
                  "bindLabel": "name",
                  "bindValue": "id",
                  "displayColumns": [
                    { "key": "name", "header": "Name" }
                  ]
                }
              }
            }
          },
          {
            "style": { "gridColumn": "span 3" },
            "control": {
              "label": "active",
              "displayLabel": "Active",
              "disabled": false,
              "skipLabel": true,
              "defaultValue": true,
              "fieldInfo": { "dataType": "boolean" }
            }
          }
        ]
      },
      {
        "formGroups": [
          {
            "style": { "gridColumn": "span 6" },
            "control": {
              "label": "description",
              "displayLabel": "Description",
              "disabled": false,
              "placeHolder": "Enter a description...",
              "fieldInfo": { "dataType": "textarea" }
            }
          }
        ]
      }
    ]
  }
